import React from 'react';
import { useLang } from '../../i18n/LanguageContext';

/*
 * Three letters, not a dropdown.
 *
 * The desk switches this and switches it back; a select would cost two clicks
 * and a decision each way. It stays on the machine it was set on, so the
 * receptionist's till can be in Telugu while the owner's laptop is not.
 */
export default function LanguageToggle({ compact = false, dark = false }) {
  const { lang, setLang } = useLang();
  const opts = [
    { id: 'en', label: 'EN', title: 'English' },
    { id: 'te', label: 'తె', title: 'తెలుగు' },
    { id: 'hi', label: 'हि', title: 'हिंदी' },
  ];
  return (
    <div className="inline-flex rounded-lg overflow-hidden shrink-0"
      style={{ border: dark ? '1px solid rgba(255,255,255,0.12)' : '1px solid var(--os-border)' }}>
      {opts.map((o) => (
        <button key={o.id} type="button" onClick={() => setLang(o.id)} title={o.title}
          aria-pressed={lang === o.id}
          className={`font-semibold transition-colors ${compact ? 'px-2 py-0.5 text-[0.8333rem]' : 'px-2.5 py-1 text-[0.9167rem]'}`}
          style={lang === o.id
            ? { background: '#C8952C', color: '#fff' }
            : dark
              ? { background: 'rgba(255,255,255,0.04)', color: 'rgba(255,255,255,0.45)' }
              : { background: 'var(--os-surface)', color: 'var(--os-ink-3)' }}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
